export const MUSINSA_S1_MAP_ID = process.env.REACT_APP_MUSINSA_S1_MAP_ID ?? '4f52b95a-785a-4da9-bac7-67f8c67e7a7b';
